import moment from 'moment';

function getOrdinal(n: number): string {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return `${n}${s[(v - 20) % 10] || s[v] || s[0]}`;
}
export const getDisplayString = (
  dateString: any,
  fromRequiredDoc = false,
  doc?: any,
  maxProgressNoteDays?: any,
  source?: string,
  isDocDuePNAlert?: any
) => {
  if (!dateString) {
    return '-';
  }
  const currentDate = moment().startOf('day');
  const inputDate = moment(dateString).startOf('day');
  const diffInDays = currentDate.diff(inputDate, 'days');

  // weekly progress note alert
  if (isDocDuePNAlert && doc?.formType?.includes('WEEKLY_PROGRESS_NOTE')) {
    const [xStr, yStr] = doc?.visits?.split('/') || [];
    const x = parseInt(xStr, 10);
    const y = parseInt(yStr, 10);

    const isDueToday =
      source === 'RECHECK_ALERT'
        ? getStatus(dateString) === doc?.status
        : doc?.status === 'DUE TODAY';
    const isUpcoming =
      source === 'RECHECK_ALERT'
        ? getStatus(dateString) === doc?.status
        : doc?.status === 'UPCOMING DEADLINE';
    const isOverdue =
      source === 'RECHECK_ALERT' ? getStatus(dateString) === 'OVERDUE' : doc?.status === 'OVERDUE';

    const reason = doc?.alertReason;
    if (isDueToday && reason === 'LAST_VISIT_SCHEDULED') {
      const visitLabel = getOrdinal(y);
      return `${visitLabel} Visit Today`;
    }

    if (isUpcoming && reason === 'LAST_VISIT_SCHEDULED') {
      const visitLabel = getOrdinal(y);
      return `${visitLabel} Visit Scheduled`;
    }

    if (isDueToday && reason === 'LAST_VISIT_COMPLETED') {
      const visitLabel = getOrdinal(y);
      return `${visitLabel} Visit Completed`;
    }

    if (isDueToday && reason === 'MAX_DAY_REACHED') {
      const visitLabel = getOrdinal(maxProgressNoteDays);
      return `${visitLabel} Day Reached`;
    }

    if (isUpcoming && reason === 'ALERT_FOR_FUTURE') {
      const remainingDays =
        diffInDays && maxProgressNoteDays ? maxProgressNoteDays - Math.abs(diffInDays) : 0;

      return `${remainingDays}/${maxProgressNoteDays} Days`;
    }

    if (isOverdue) {
      if (reason === 'LAST_VISIT_COMPLETED') {
        const visitLabel = getOrdinal(y);
        return `${visitLabel} Visit Completed`;
      }

      if (reason === 'MAX_DAY_REACHED') {
        const visitLabel = getOrdinal(maxProgressNoteDays);
        return `${visitLabel} Day Reached`;
      }
    }
  }

  if (diffInDays === 0) {
    return 'Today';
  } else if (diffInDays === 1) {
    return 'Yesterday';
  } else if (diffInDays === -1) {
    return 'Tomorrow';
  } else {
    const absoluteDiffInDays = Math.abs(diffInDays);
    const daysString = absoluteDiffInDays > 1 ? `${absoluteDiffInDays} Days` : '1 Day';

    if (diffInDays > 0) {
      return `${daysString} Ago`;
    } else {
      if (fromRequiredDoc) {
        return `In ${daysString}`;
      } else {
        return `${daysString} To Go`;
      }
    }
  }
};

function getStatus(dueDateStr: string): 'DUE TODAY' | 'UPCOMING DEADLINE' | 'OVERDUE' {
  const getDateParts = (dateStr: string) => {
    const [year, month, day] = dateStr.split('-').map(Number);
    return { year, month, day };
  };

  const getTodayParts = (): { year: number; month: number; day: number } => {
    const now = new Date();
    return {
      year: now.getUTCFullYear(),
      month: now.getUTCMonth() + 1,
      day: now.getUTCDate(),
    };
  };

  const due = getDateParts(dueDateStr);
  const today = getTodayParts();

  const dueDateValue = new Date(Date.UTC(due.year, due.month - 1, due.day)).getTime();
  const todayValue = new Date(Date.UTC(today.year, today.month - 1, today.day)).getTime();

  if (todayValue === dueDateValue) return 'DUE TODAY';
  if (todayValue < dueDateValue) return 'UPCOMING DEADLINE';
  return 'OVERDUE';
}